import {
  TemplateChatbotSchema
} from "./chunk-S32O2WNK.mjs";
import {
  ModifiedTemplateInterfaceSchema,
  TemplateInterfaceSchema
} from "./chunk-BKYFLSFS.mjs";
import {
  ZapSchemaOptional
} from "./chunk-TDLPIO7B.mjs";
import {
  ModifiedTableSchema,
  TemplateTableSchema
} from "./chunk-EUFCBK6R.mjs";

// types/index.ts
import { z } from "zod";
var agentOutputZSLSchema = z.object({
  name: z.string(),
  description: z.string(),
  parameters: z.array(
    z.object({
      key: z.string(),
      default: z.string()
    })
  ).describe(
    "Always include a 'projectName' parameter with an appropriate default value"
  ),
  chatbots: z.array(TemplateChatbotSchema),
  interfaces: z.array(TemplateInterfaceSchema),
  tables: z.array(TemplateTableSchema),
  zaps: z.array(ZapSchemaOptional)
});
var ModifiedFinalZSLSchema = agentOutputZSLSchema.extend({
  interfaces: z.array(ModifiedTemplateInterfaceSchema),
  tables: z.array(ModifiedTableSchema)
});
var ZslAssetTypeSchema = z.enum([
  "zap",
  "interface",
  "table",
  "chatbot"
]);

export {
  agentOutputZSLSchema,
  ModifiedFinalZSLSchema,
  ZslAssetTypeSchema
};
